import { resolveDwbTrainingCourseCodeFromRoute } from 'utils/program/training'

function resolveTrainingCourseCode({ trainingLinkSummary, contentGroupCode }) {
  return resolveDwbTrainingCourseCodeFromRoute(
    trainingLinkSummary?.route,
    contentGroupCode,
  )
}

/**
 * Resolves the curriculum-service coursePointer for a unit's training summary.
 * Prefers an explicit pointer on the summary; falls back to route-band mapping.
 */
export function resolveTrainingCoursePointer({
  trainingLinkSummary,
  contentGroupCode,
}) {
  if (!trainingLinkSummary) return null

  if (trainingLinkSummary.coursePointer)
    return trainingLinkSummary.coursePointer

  const courseCode = resolveTrainingCourseCode({
    trainingLinkSummary,
    contentGroupCode,
  })

  if (!courseCode) return null

  return {
    query: {
      courseCode,
    },
  }
}

/**
 * Resolves the LMS course node id for a unit's training summary from
 * courseNodeConnector metadata when curriculum-service provides it.
 */
export function resolveTrainingCourseNodeId(trainingLinkSummary) {
  if (!trainingLinkSummary) return null

  const connector = trainingLinkSummary.courseNodeConnector
  return (
    connector?.courseNodeEntryPoint ||
    connector?.course_node_entry_point ||
    connector?.id ||
    null
  )
}
